import { render, staticRenderFns } from "./questions.vue?vue&type=template&id=37280dab&"
import script from "./script/questions.js?vue&type=script&lang=js&"
export * from "./script/questions.js?vue&type=script&lang=js&"
import style0 from "./questions.vue?vue&type=style&index=0&id=37280dab&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports